/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  InfoOverlayContent
 */

/** @jsx jsx */
import { Box, useColorModeValue } from '@chakra-ui/react'
import { jsx } from '@emotion/react'
import type { Listable } from '@zcode/state-type'
import React from 'react'
import { AmenitiesInfo } from '../AmenitiesInfo/AmenitiesInfo'
import { OverlayModifierText } from '../OverlayModifierText/OverlayModifierText'
import * as style from './style'

export interface Props {
  dateAvailableText?: string
  listable: Listable
  shortDescriptionText?: string
  showAmenities: boolean
  showShortDescription: boolean
  verticalSpecificDetail?: string
  isMobile?: boolean
  isLargeCard?: boolean
  propertyType: any
  verticalsArray?: string[]
}

export const InfoOverlayContent = ({
  dateAvailableText,
  listable,
  shortDescriptionText,
  showAmenities,
  showShortDescription,
  verticalSpecificDetail,
  isMobile,
  isLargeCard,
  propertyType,
  verticalsArray,
}: Props) => {
  const color = useColorModeValue('gray.600', 'gray.100')
  return (
    <React.Fragment>
      <OverlayModifierText
        dateAvailable={dateAvailableText}
        propertyType={propertyType}
        verticalsArray={verticalsArray}
      />
      {verticalSpecificDetail && !showShortDescription && (
        <Box<'div'> color={color} fontSize="sm" mt={{ base: 5, md: 3.5 }}>
          {verticalSpecificDetail}
        </Box>
      )}
      {showAmenities && (
        <AmenitiesInfo isLargeCard={isLargeCard} isMobile={isMobile} listable={listable} />
      )}
      {showShortDescription && shortDescriptionText && (
        <Box<'div'>
          color={color}
          css={style.lineClamp}
          fontSize="sm"
          height="112px"
          mt={{ base: 5, md: 3.5 }}
        >
          {shortDescriptionText}
        </Box>
      )}
    </React.Fragment>
  )
}
